@import '../../style/globals.scss';

.Modal {
    width: 700px;
    max-width: calc(100% - 40px);
    height: auto;
    min-height: 574px;
}

.GenericLeaderboard {
    position: relative;
    font-size: $font-size-p;

    @media (max-width: $bp-xxs) {
        font-size: $font-size-small;
    }

    h3 {
        font-size: 16px;
    }

    table {
        width: 100%;
        margin-bottom: 20px;
        border-collapse: separate;
        border-spacing: 0 10px;
        text-align: left;

        td,
        th {
            padding: 5px;
        }

        tr {
            background-color: var(--token-accent-theme-1-interface-brand-interface-midground);
        }
    }
}
